import I18n from 'I18n';
import companyObjectTypeId from 'ui-forms-components/constants/objectTypeIds/companyObjectTypeId';
import contactObjectTypeId from 'ui-forms-components/constants/objectTypeIds/contactObjectTypeId';
import customObjectTypeId from 'ui-forms-components/constants/objectTypeIds/customObjectTypeId';
import dealObjectTypeId from 'ui-forms-components/constants/objectTypeIds/dealObjectTypeId';
import ticketObjectTypeId from 'ui-forms-components/constants/objectTypeIds/ticketObjectTypeId';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { getSubmissionsRoute } from 'FormsUI/lib/RouteGenerators';
import { Tabs } from 'FormsUI/constants/Submissions';
import { ColumnLangKeys, Columns } from 'FormsUI/constants/Dashboard';
import { FormType, LastModifiedValue } from 'FormsUI/components/comparison/PreviewAttributes';
import FormattedPerformanceRowValue from 'FormsUI/components/comparison/FormattedPerformanceRowValue';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import FormattedRowValue from 'FormsUI/components/comparison/FormattedRowValue';
import { VALUE_TYPES } from 'FormsUI/constants/ComparisonTool';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getPreviewName = ({
  contentObject
}) => {
  return {
    value: contentObject.name,
    href: getSubmissionsRoute(contentObject.guid, Tabs.PERFORMANCE)
  };
};
export const previewGetAttributes = ({
  contentObject,
  contentStatistics
}) => ({
  left: {
    label: 'comparison.cards.overview.formType',
    value: /*#__PURE__*/_jsx(FormType, {
      value: contentStatistics.formType
    })
  },
  right: {
    label: `dashboard.table.columns.${ColumnLangKeys[Columns.LAST_MODIFIED]}`,
    value: /*#__PURE__*/_jsx(LastModifiedValue, {
      value: contentObject.updatedAt
    })
  }
});
const getFormFieldData = ({
  formFieldData,
  key
}) => {
  const fieldsArray = formFieldData ? formFieldData.reduce( /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  (acc, {
    fields
  }) => [...acc, fields], []).flat() : [];
  const formFields = {
    totalNoOfFields: fieldsArray.length,
    contactProperties: 0,
    companyProperties: 0,
    ticketProperties: 0,
    dealProperties: 0,
    customObjectProperties: 0,
    progressiveFieldLogic: fieldsArray.filter(el => el.isSmartField).length,
    dependentFieldLogic: fieldsArray.filter(el => el.dependentFieldFilters.length).length
  };
  fieldsArray.forEach(field => {
    switch (field.objectTypeId) {
      case contactObjectTypeId:
        formFields.contactProperties += 1;
        break;
      case ticketObjectTypeId:
        formFields.ticketProperties += 1;
        break;
      case companyObjectTypeId:
        formFields.companyProperties += 1;
        break;
      case dealObjectTypeId:
        formFields.dealProperties += 1;
        break;
      default:
        if (field.objectTypeId.startsWith(customObjectTypeId)) {
          formFields.customObjectProperties += 1;
        }
    }
  });
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return formFields[key];
};
const convertToUpperCase = ({
  result
}) => {
  return `${result.charAt(0).toUpperCase()}${result.slice(1)}`;
};
const getStyleData = ({
  styleData,
  key
}) => {
  if (!styleData) return undefined;
  if (styleData[key] && styleData[key].startsWith('#')) return styleData[key];
  const result = styleData[key] && styleData[key].split(',')[0];
  return result && convertToUpperCase({
    result
  });
};
const getRowValue = ({
  key,
  contentObject,
  contentStatistics,
  fromObject,
  fromStatistics,
  usesStyle,
  isFormField
}) => {
  if (fromObject) {
    return contentObject[key];
  } else if (fromStatistics && usesStyle) {
    const styleData = contentStatistics.style && JSON.parse(contentStatistics.style);
    return getStyleData({
      styleData,
      key
    });
  } else if (fromStatistics && isFormField) {
    const formFieldData = contentStatistics.formFieldGroups;
    return getFormFieldData({
      formFieldData,
      key
    });
  } else if (fromStatistics) {
    if (key === 'themeName') {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: `theme.${contentStatistics[key]}`
      });
    }
    return contentStatistics && contentStatistics[key];
  } else return 0;
};
const getHref = (id, linkPath) => getSubmissionsRoute(id, linkPath);
const isPerformanceSection = section => section === 'overview';
export const canShowPreview = formType => formType === FormTypes.HUBSPOT;
export const generateGetStatsRows = sectionConfig => {
  return ({
    contentObject,
    contentStatistics
  }) => {
    return sectionConfig.rows.map(({
      key,
      linkPath = '',
      fromObject = false,
      fromStatistics = false,
      usesStyle = false,
      isFormField = false,
      asPercentage = false,
      asDate = false,
      asBoolean = false,
      asYesNo = false,
      asColor = false,
      isResizable = false,
      fallback = 0
    }) => {
      const value = getRowValue({
        key,
        contentObject,
        contentStatistics,
        fromObject,
        fromStatistics,
        usesStyle,
        isFormField
      });
      const valueType = asColor ? VALUE_TYPES.COLOR : asPercentage ? VALUE_TYPES.PERCENTAGE : asDate ? VALUE_TYPES.DATE : asBoolean ? VALUE_TYPES.BOOLEAN : asYesNo ? VALUE_TYPES.YES_NO : null;
      return {
        label: `comparison.cards.${sectionConfig.section}.${key}`,
        href: linkPath && getHref(contentObject.guid, linkPath),
        isResizable,
        value: isPerformanceSection(sectionConfig.section) ? /*#__PURE__*/_jsx(FormattedPerformanceRowValue, {
          value: value,
          fieldKey: key,
          formType: contentStatistics.formType
        }) : /*#__PURE__*/_jsx(FormattedRowValue, {
          value: value,
          valueType: valueType,
          fallback: fallback
        })
      };
    });
  };
};
export const timestampToStartDate = timestamp => I18n.moment(parseInt(timestamp, 10) || 0).portalTz().format('YYYY-MM-DD');
export const timestampToEndDate = timestamp => I18n.moment(parseInt(timestamp, 10) || I18n.moment().portalTz().valueOf()).portalTz().format('YYYY-MM-DD');
export const getDefaultRowValue = value => typeof value === 'string' ? value.replace(/<\/?[^>]+(>|$)/g, '') : value;